// PageVariablesEmpresas.js

export const pageVariables = {
    headers: [
        'NOME', 'CNPJ', 'ENDEREÇO', 'TELEFONE', 'EMAIL', 'DATA DE CADASTRO'
    ],
    headerInfo: {
        title: "Empresas",
        description: "Esta seção fornece informações detalhadas sobre as empresas, incluindo dados como nome, setor de atuação e status atual. Acompanhe os segurados associados e os contratos empresariais para garantir uma gestão eficiente e integrada."
    },    
    inputs: [
        {
            name: "nome",
            type: "text",
            label: "Nome"
        },
        {
            name: "cnpj",
            type: "text",
            label: "Cnpj"
        },
        {
            name: "endereco",
            type: "text",
            label: "Endereço"
        },
        {
            name: "telefone",
            type: "text",
            label: "Telefone"
        }
        ,
        {
            name: "email",
            type: "email",
            label: "E-mail"
        }
    ],
    page: process.env.VUE_APP_API_URL+"empresas",
    pagePlanos: process.env.VUE_APP_API_URL+"planos",
    empresasGetPage: process.env.VUE_APP_API_URL+"getEmpresas",
    uploadDataPage: process.env.VUE_APP_API_URL+"empresas/csv",
};
